import AxiosDefault from "services/AxiosDefault";

export const getDisputesAPI = async (data) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/disputes/get",
    data,
  });
  return response;
};
